import TopbarOrderButton from "@components/TopbarCartButton";
import { useWindowSize } from "@utils/hooks";
// it's necessary to import the types in this way to not get error when create a new Image()
import * as Types from "@utils/types";
import ZoomOnHover from "@utils/zoom";
import * as React from "react";
import { IoChevronBack } from "react-icons/io5";
import { Carousel } from "react-responsive-carousel";
import { useNavigate, useParams } from "react-router";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import Styled from "./styled";
interface ProductImagesCarouselProps {
  product: Types.Product; // product is necessary in order to get image proper urls
}

export const ProductHeader: React.FC = () => {
  const navigate = useNavigate();
  const { product_id } = useParams();

  const handleGoBack = () => {
    navigate(`/`, { state: { product_id } });
  };

  return (
    <Styled.HeaderContainer className={"border-bottom px-2"}>
      <div>
        <Styled.GoBackButton>
          <IoChevronBack onClick={handleGoBack} size={24} />
        </Styled.GoBackButton>
      </div>
      <div>
        <TopbarOrderButton />
      </div>
    </Styled.HeaderContainer>
  );
};

export const ProductImagesCarousel: React.FC<ProductImagesCarouselProps> = ({ product }) => {
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [imagesWidth, setImagesWidth] = React.useState<number[]>([]);
  const images = product.images;
  const { width } = useWindowSize();
  const containerRef = React.useRef<HTMLDivElement>(null);

  const getImageUrl = (img: Types.Image) => {
    return `${img.base_url}/products/${product.id}/thumb_3/${img.key}`;
  };

  const getFinalWidth = (imgUrl: string): Promise<number> => {
    const image = new Image();
    image.src = imgUrl;
    return new Promise((resolve) => {
      image.onload = () => {
        if (containerRef.current) {
          const containerRatio = containerRef.current?.clientWidth / containerRef.current?.clientHeight;
          const imageRatio = image.width / image.height;
          if (imageRatio > containerRatio) {
            resolve(containerRef.current?.clientWidth);
          }
          if (imageRatio < containerRatio) {
            resolve(imageRatio * containerRef.current?.clientHeight);
          }
          if (imageRatio === containerRatio) {
            resolve(containerRef.current?.clientWidth);
          }
        } else {
          resolve(0);
        }
      };
    });
  };

  React.useEffect(() => {
    setImagesWidth([]);
    images.forEach(async (img) => {
      const finalWidth = await getFinalWidth(getImageUrl(img));
      setImagesWidth((prev) => [...prev, finalWidth]);
    });
  }, [width]);

  return (
    <div style={{ backgroundColor: "white" }}>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        plugins={[Zoom]}
        zoom={{
          maxZoomPixelRatio: 2,
        }}
        carousel={{
          finite: true,
        }}
        slides={images.map((image) => ({
          src: `${image.base_url}/products/${product.id}/thumb_3/${image.key}`,
        }))}
      />

      <Carousel
        selectedItem={currentSlide}
        showStatus={false}
        showThumbs={false}
        showIndicators={false}
        showArrows={false}
        dynamicHeight={true}
        preventMovementUntilSwipeScrollTolerance={true}
        swipeable={width < 768 ? true : false}
        onChange={(index) => {
          setCurrentSlide(index);
        }}
      >
        {images.map((image, index) =>
          width < 768 ? (
            <div
              onClick={() => {
                setOpen(true);
              }}
              key={image.id}
              style={{ height: 450, maxHeight: 450, overflow: "hidden" }}
            >
              <img
                key={image.id}
                alt="product-img"
                src={`${image.base_url}/products/${product.id}/thumb_3/${image.key}`}
                height={"100%"}
                style={{ objectFit: "contain" }}
              />
            </div>
          ) : (
            <div ref={containerRef} className="d-flex flex-column align-items-center" style={{ height: 450, maxHeight: 450, overflow: "hidden" }} key={index}>
              <ZoomOnHover imgUrl={getImageUrl(image)} zoomScale={2} height={450} width={imagesWidth[index]} />
            </div>
          ),
        )}
      </Carousel>
      <div className="d-flex flex-row justify-content-start p-3 mx-0 gap-4 overflow-auto">
        {images.map((image, index) => (
          <div
            key={image.id}
            className={`d-flex justify-content-center align-items-center`}
            style={{
              border: `${index === currentSlide ? "1px solid black" : "1px solid #f5f5f5"}`,
              borderRadius: 5,
              minWidth: 30,
              maxWidth: 50,
              height: 50,
              overflow: "hidden",
            }}
            onMouseEnter={() => {
              setCurrentSlide(index);
            }}
            onClick={() => {
              setCurrentSlide(index);
            }}
          >
            <img alt="product-img" src={getImageUrl(image)} height={"100%"} style={{ objectFit: "scale-down" }} />
          </div>
        ))}
      </div>
    </div>
  );
};
